import { ValidationError } from 'portal/src/utils/ValidationError';

export interface ValidatorBody<T> {
  message: string;
  validate: () => T | Promise<T>;
}

export class ValidateGuard {
  /**
   * Runs an array of validators and accumulates errors.
   * If any validation fails, it throws a ValidatorError with all messages.
   * @param {ValidatorBody<boolean | Promise<boolean>>[]} validators
   * @throws {ValidatorError} If any validation fails.
   */
  static async validate(
    validators: ValidatorBody<boolean | Promise<boolean>>[],
  ): Promise<void> {
    const errors: string[] = [];

    for (const { validate, message } of validators) {
      const passed = await validate();
      if (!passed) {
        errors.push(message);
      }
    }

    if (errors.length) {
      throw new ValidationError(errors);
    }
  }
}
